import { FlexContainer, GridContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const RowContainerGrid = styled(GridContainer)`
  text-align: left;
  padding: 0 0rem 3.2rem 0rem !important;
`;

export const CellContainer = styled(FlexContainer)`
  flex-direction: column;
  border-bottom: 0.1rem solid rgba(204, 212, 229, 1);
  padding: 1.6rem 1.2rem;
  &:last-of-type {
    flex: 1 0 calc(100% / 3);
  }
`;

export const CardContainer = styled.div`
  padding: 0 0rem 3.2rem 0rem !important;
`;
